import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-donate',
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.scss'],
})
export class DonateComponent {
  public paypalDonateUrl = environment.paypalDonateUrl;

  public donate(): void {
    window.open(this.paypalDonateUrl, '_blank');
  }
}
